<template>
    <!--<div  class="casestudiesitemsmall" v-bind:class="{ debug1:caseitemsmall.index%2==0, debug2:caseitemsmall.index%2==1}" >-->
    <div  class="casestudiesitemsmall" v-bind:class="{ sizesmall:flagtype=='case', sizelarge:flagtype=='news'}" >
        <a :href="keyurl">
            <img :src="defaultimagesrc" />
        </a>
        <div class="title_casestudiesitemsmall">{{caseitemsmall.title}}</div>
        <div class="divisore_casestudiesitemsmall"></div>
        <div v-if="caseitemsmall.company!=''" class="company_casestudiesitemsmall">{{caseitemsmall.company}}</div>
        <div v-if="caseitemsmall.company!=''" class="divisore_casestudiesitemsmall"></div>
        <div v-if="caseitemsmall.year!=''" class="year_casestudiesitemsmall">{{caseitemsmall.year}}</div>
        <div v-if="caseitemsmall.year!=''" class="divisore_casestudiesitemsmall"></div>
        <div v-if="caseitemsmall.tags.length>0" class="tags_casestudiesitemsmall">
          <span  v-for="tag in caseitemsmall.tags" :key="tag">{{tag}}</span>
        </div>
        <div v-if="caseitemsmall.tags.length>0" class="divisore_casestudiesitemsmall"></div>
        <div  v-if="flagtype=='news'"  class="description_casestudiesitemsmall">{{truncateddescription}}</div>
        <div  v-if="flagtype=='news'"  class="continuetoread_casestudiesitemsmall"><a :href="keyurl">{{continuetoreadlabel}}</a></div>
        
        
        
    </div>
 
</template>

<script>
import backendmixin from '../mixins/backendmixin.js';
import multilangmixin from "../mixins/multilangmixin.js"
// eslint-disable-next-line no-unused-vars

export default {
  
  name: "cmpcasestudiessmall",
  mixins:[multilangmixin,backendmixin],
  props:["caseitemsmall","flagtype"],
    

  data(){
      return {

            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);
     
  },

  mounted(){
    
  },

  computed:{
      defaultimagesrc(){
        return this.fnGetImageUrl(this.caseitemsmall.defaultimage);
      },
      keyurl(){
        return "/"+this.currentlang+"/caseitem?key="+this.caseitemsmall.key;
      },

      

      truncateddescription()
      {
        let wlen=200;
        if (this.caseitemsmall.description.length>wlen)
        {
          return this.caseitemsmall.description.substring(0, wlen)+" ...";
        }
        else
        {
          return this.caseitemsmall.description;
        }
        
      },

      continuetoreadlabel()
      {
        return this.fnGetTranslation(this.currentlang,"continuaaleggere");
      }
      

  },


  methods:{


  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    
  .title_casestudiesitemsmall{
    margin-top: 2vh;
    font-size: 1em;
    font-weight: bold;
  }

  .company_casestudiesitemsmall{
    margin-top: 0.4vh;
    font-size: 1em;
    font-weight: 400;
  }

  .year_casestudiesitemsmall{
    margin-top: 0.4vh;
    font-size: 1em;
    font-weight: 400;
  }

  .tags_casestudiesitemsmall
  {
    margin-top: 0.4vh;
    font-size: 0.8em;
    font-weight: 400;
  }

  .tags_casestudiesitemsmall span
  {
    margin-right: 0.5vh;
    /*background-color: #e6e4e4;*/
    background-color: #ffdd00;
    
  }


  .divisore_casestudiesitemsmall{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    background-color: black;
    width: 18px;    
    height: 2px;    
  }

  

  .casestudiesitemsmall a img{
    width: 100%;
  }

  .description_casestudiesitemsmall{
    white-space: pre-line;
  }

  .continuetoread_casestudiesitemsmall
  {
    font-size: 0.7em;
    width: 100%;
    font-weight: bold;
    margin-top: 1vh;
    text-align: left;
  }




  .continuetoread_casestudiesitemsmall a 
  {
    color: black; 
    text-decoration: none;
  }

  .continuetoread_casestudiesitemsmall  a:visited{
    color: black;
    text-decoration: none;
  }

  .continuetoread_casestudiesitemsmall a:active{
    color: black;
    text-decoration: none;
  }

  .continuetoread_casestudiesitemsmall a:hover{

  color: #ffdd00;
  font-weight: bold;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: white;
  text-decoration-thickness: 0.3em;
  }




/*
  .debug1
  {
    background-color: aquamarine;
  }

  .debug2
  {
    background-color: red;
  }

*/


  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
    .casestudiesitemsmall{
        
        margin: 1vh;    
    }

    .sizesmall{
        width: 270px;
    }

    .sizelarge{
        width: 370px;
    }

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
    
    .casestudiesitemsmall{
        width: 100%;
        margin-bottom: 2em;
        

    }
 
  }


</style>
